import './AccountPlanCard.css';
import React from 'react';
import { cx } from '#/Scripts/utilities/cx';
import RadioButton from '#sign-up/components/common/RadioButton/FormRadioButton';

interface AccountPlanProps {
  title: string;
  value: string;
  name: string;
  checked: boolean;
  hasError?: boolean;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

const AccountPlanCard: React.FC<AccountPlanProps> = ({ title, value, name, checked, hasError, inputProps }) => {
  const { onChange, ...restInputProps } = inputProps || {};

  return (
    <label htmlFor={value} className={cx('account-plan-card', checked && 'active', hasError && 'error')}>
      <div className="account-plan-header">
        <RadioButton
          {...restInputProps}
          name={name}
          id={value}
          value={value}
          label={title}
          checked={checked}
          onChange={onChange || (() => {})}
        />
      </div>
    </label>
  );
};

export default AccountPlanCard;
